class StoryHightlightSwiperSlide extends HTMLElement {
  constructor() {
      super();
      this.casouselSlide = this.querySelector('.story__slideshow');
      new Swiper(this.casouselSlide, {
          loop: true,
          speed: 600,
          autoHeight: false,
          centeredSlides: false,
          roundLengths: true,
          // Navigation arrows
          navigation: {
              nextEl: '.story-button-next',
              prevEl: '.story-button-prev',
          },
          breakpoints: {
              749: {
                  slidesPerView: 3,
                  spaceBetween: 0,
              }
          },
      });
  }
}
customElements.define("story-hightlight-container", StoryHightlightSwiperSlide);
